import React from 'react';

import { CarsViewToggleWrapper } from '@/modules/CarsStock/components/common.styles';
import CarsViewToggle from '@/components/CarViewToggle';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import { getCarListView, setCarListView } from '@/store/reducers/cars-stock';
import { CarViewTypes } from '@/components/CarViewToggle/types';
import { useStyledComponentsTheme } from '@/theme/hooks';

function ViewToggle() {
  const theme = useStyledComponentsTheme();
  const dispatch = useTypedDispatch();
  const view = useTypedSelector(getCarListView);

  const handleChangeView = (view: CarViewTypes) => {
    dispatch(setCarListView(view));
  };

  return (
    <CarsViewToggleWrapper>
      <CarsViewToggle
        view={view}
        onChange={handleChangeView}
        color={theme.main}
      />
    </CarsViewToggleWrapper>
  );
}

export default ViewToggle;
